/* axios */
import { AxiosError } from 'axios'
/* services bases */
import { ApiService } from './constant.services'
/* models */
import { CreditDetailResquest } from '@models'

export const CreditDetailServices = async (id: number) => {
    try {
        const response = await ApiService.get<CreditDetailResquest>(`credit/${id}`)

        if (response.data.error === true) return response.data

        return response.data
    } catch (error) {
        const err = error as AxiosError

        console.log(err.response?.data)

        return err.response?.data
    }
}
